module.exports = __webpack_public_path__ + "img/bust_dart_height.2e5669a6.png";